import { createModalStoreFactory } from '@/features/_shared/stores/create-modal.store';
import { useShallow } from 'zustand/shallow';
import type {
  IDeleteAgentModalProps,
  TDeleteAgentModalType,
} from '@/features/users/agent/components/modals/delete-agent-modal/delete-agent-modal';
import type {
  IDeleteInviteAgentModalProps,
  TDeleteInviteAgentModalType,
} from '@/features/users/agent/components/modals/delete-invite-agent-modal/delete-invite-agent-modal';
import type {
  IInviteAgentModalProps,
  TInviteAgentModalType,
} from '@/features/users/agent/components/modals/invite-agent-modal/invite-agent-modal';
import type {
  IPendingInviteAgentModalProps,
  TPendingInviteAgentModalType,
} from '@/features/users/agent/components/modals/pending-invite-agent-modal/pending-invite-agent-modal';
import type {
  ISetAsAdminAgentModalProps,
  TSetAsAdminAgentModalType,
} from '@/features/users/agent/components/modals/set-as-admin-modal/set-as-admin-agent-modal';
import type {
  ICreateTeamModalProps,
  TCreateTeamModalType,
} from '../../../team/components/modals/create-team-modal/create-team-modal';
import type {
  IDeleteTeamModalProps,
  TDeleteTeamModalType,
} from '../../../team/components/modals/delete-team-modal/delete-team-modal';
import type {
  IDeleteAgentOnTeamModalProps,
  TDeleteAgentOnTeamModalType,
} from '../../../team/components/modals/delete-agent-on-team-modal/delete-agent-on-team-modal';
import {
  IInviteAgentToTeamModalProps,
  TInviteAgentToTeamModalType,
} from '../../../team/components/modals/invite-agent-to-team/invite-agent-to-team';

// --------- User Modal Root Types ---------
export type TUserModalRootTypes =
  | TDeleteAgentModalType
  | TDeleteInviteAgentModalType
  | TInviteAgentModalType
  | TPendingInviteAgentModalType
  | TSetAsAdminAgentModalType
  | TCreateTeamModalType
  | TDeleteTeamModalType
  | TDeleteAgentOnTeamModalType
  | TInviteAgentToTeamModalType;

// --------- User Modal Root Props ---------
type TUserModalRootProps = {
  // Agent Modal
  DeleteAgentModal: IDeleteAgentModalProps;
  DeleteInviteAgentModal: IDeleteInviteAgentModalProps;
  InviteAgentModal: IInviteAgentModalProps;
  PendingInviteAgentModal: IPendingInviteAgentModalProps;
  SetAsAdminAgentModal: ISetAsAdminAgentModalProps;

  // Team Modal
  CreateTeamModal: ICreateTeamModalProps;
  DeleteTeamModal: IDeleteTeamModalProps;
  DeleteAgentOnTeamModal: IDeleteAgentOnTeamModalProps;
  InviteAgentToTeamModal: IInviteAgentToTeamModalProps;
};

export const useUserModalRootStore = createModalStoreFactory<TUserModalRootTypes, TUserModalRootProps>();

export const useUserModalRootActionsStore = () => useUserModalRootStore(useShallow((state) => state.actions));
